<template>
  <div>
    <time-line></time-line>
    <welcome v-if="!$route.params.year"></welcome>
    <countries v-else></countries>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TimeLine from "@/components/TimeLine.vue";
import Countries from "@/components/Countries.vue";
import Welcome from "@/components/Welcome.vue";
import YearsMixin from "../mixins/YearsMixin";
import _ from "lodash";

export default {
  name: "Layout",
  components: {
    TimeLine,
    Countries,
    Welcome
  },
  mixins: [YearsMixin],
  data() {
    return {};
  },
  created() {
    if (
      !_.includes(
        _.map(this.years, year => {
          return year.date;
        }),
        this.$route.params.year
      )
    ) {
      this.$router.replace({
        name: "MainContent"
      });
    }
  }
};
</script>


<style scoped>
</style>
